import { defineComponent as r, createBlock as n, openBlock as a, unref as p, mergeProps as i, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowUpRight",
  __name: "IconArrowUpRight",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (l, e) => (a(), n(p(s), i(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M17.614 12.707a.75.75 0 0 0 1.5 0V6.136a1.25 1.25 0 0 0-1.25-1.25h-6.571a.75.75 0 0 0 0 1.5h5.26L5.106 17.834a.75.75 0 0 0 1.06 1.06L17.614 7.447v5.26" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
